import { useTranslation } from "react-i18next";

import type { TFunction } from "i18next";

export enum LANGUAGE_OPTIONS {
  All = "All",
  Dutch = "nl-NL",
  English = "en-GB",
  French = "fr-FR",
  German = "de-DE"
}

const getLanguageDropdownOptions = (t: TFunction) => [
  { text: t("v8_all_languages", "All Languages"), value: LANGUAGE_OPTIONS.All, key: LANGUAGE_OPTIONS.All },
  { text: t("v8_dutch", "Dutch"), value: LANGUAGE_OPTIONS.Dutch, key: LANGUAGE_OPTIONS.Dutch },
  { text: t("v8_english", "English"), value: LANGUAGE_OPTIONS.English, key: LANGUAGE_OPTIONS.English },
  { text: t("v8_french", "French"), value: LANGUAGE_OPTIONS.French, key: LANGUAGE_OPTIONS.French },
  { text: t("v8_german", "German"), value: LANGUAGE_OPTIONS.German, key: LANGUAGE_OPTIONS.German }
];

export const useLanguageOptions = () => {
  const { t } = useTranslation();

  const dropdownOptions = getLanguageDropdownOptions(t);
  const getLanguageDisplayText = (language_code: string) => dropdownOptions.find(option => option.value === language_code)?.text || "";

  return { getLanguageDisplayText, dropdownOptions };
};
